<template>
  <main class="mini-program-redirect">
    <button
      class="redirect-image-button"
      type="button"
      :disabled="loading"
      :aria-busy="loading"
      aria-label="前往极兔速递小程序"
      @click="openMiniProgram"
    >
      <img
        class="redirect-image"
        src="@/assets/img/mini-program-redirect-page-image.png"
        alt="寄件用极兔，便捷稳交付，前往极兔速递小程序"
        width="1608"
        height="3496"
      >
    </button>
    <p v-if="errorMessage" class="redirect-status" role="status" aria-live="polite">
      {{ errorMessage }}
    </p>
  </main>
</template>

<script>
import { getScheme } from '@/api'

export default {
  name: 'MiniProgramRedirect',
  // 初始化页面链接和请求状态。
  data() {
    return {
      redirectUrl: '',
      loading: false,
      errorMessage: '',
    }
  },
  // 提前获取链接，确保最终跳转由用户点击直接触发。
  created() {
    this.loadRedirectUrl()
  },
  // 离开页面时关闭加载提示。
  beforeDestroy() {
    this.$toast.clear()
  },
  methods: {
    // 为无协议的域名短链补全 HTTPS，避免被浏览器解析成当前站点的相对路径。
    normalizeRedirectUrl(value) {
      if (typeof value !== 'string' || !value.trim()) return ''
      let url = value.trim()
      if (url.startsWith('//')) {
        url = `https:${url}`
      } else if (/^[a-z0-9-]+(?:\.[a-z0-9-]+)+(?:[/?#]|$)/i.test(url)) {
        url = `https://${url}`
      }
      try {
        const link = new URL(url)
        if (link.username || link.password) return ''
        const isWebLink = ['https:', 'http:'].includes(link.protocol)
        const isMiniProgramScheme = link.protocol === 'weixin:' &&
          link.hostname === 'dl' && link.pathname === '/business/' &&
          Boolean(link.searchParams.get('t'))
        return isWebLink || isMiniProgramScheme ? link.href : ''
      } catch (error) {
        return ''
      }
    },
    // 加载兜底链接，业务失败展示接口消息，请求异常展示网络提示。
    async loadRedirectUrl() {
      if (this.loading) return
      this.loading = true
      this.errorMessage = ''
      this.redirectUrl = ''
      try {
        this.$toast.loading({
          message: '加载中...',
          duration: 0,
          forbidClick: true,
        })
        const { code, msg, data } = await getScheme.getFallbackPage()
        if (code === 1) {
          this.redirectUrl = this.normalizeRedirectUrl(data)
        } else {
          this.errorMessage = msg || '加载失败，请稍后重试'
        }
      } catch (error) {
        this.errorMessage = '加载失败，请稍后重试'
      } finally {
        this.$toast.clear()
        this.loading = false
      }
    },
    // 有效链接在点击事件内同步打开；重试成功后再次点击，避免异步唤起被浏览器拦截。
    async openMiniProgram() {
      if (this.loading) return
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl
        return
      }
      await this.loadRedirectUrl()
      if (this.redirectUrl) {
        this.openMiniProgram()
      }
    },
  },
}
</script>

<style scoped>
.mini-program-redirect {
  min-height: 100vh;
  background: #fff;
}

.redirect-image-button {
  display: block;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 0;
  border: 0;
  background: #fff;
  cursor: pointer;
}

.redirect-image-button:disabled {
  cursor: wait;
}

.redirect-image-button:focus-visible {
  outline: 2px solid #e60012;
  outline-offset: -2px;
}

.redirect-image {
  display: block;
  width: 100%;
  height: auto;
}

.redirect-status {
  position: fixed;
  right: 16px;
  bottom: 20px;
  bottom: calc(20px + env(safe-area-inset-bottom));
  left: 16px;
  width: fit-content;
  max-width: calc(100% - 32px);
  margin: 0 auto;
  padding: 8px 12px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  pointer-events: none;
}
</style>
